import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ClientConfigDashboardX = lazy(() => import("./ClientConfigDashboardX"));

const CLIENTCONFIGDASH_X_ROUTES: RouteObject[] = [
  {
    path: `/private/config/:clientType`,
    element: React.createElement(ClientConfigDashboardX),
  },
];

export { CLIENTCONFIGDASH_X_ROUTES };
